import type { ForEventsMessaging } from '../../ports'
import type { EventMessage } from '../types'

export class NotificationService {
	private readonly _messaging: ForEventsMessaging

	constructor(messaging: ForEventsMessaging) {
		this._messaging = messaging
	}

	async initialize() {
		await this._messaging.connect()
	}

	subscribeToUpdates(
		subjects: string[],
		callback: (event: EventMessage) => void
	) {
		subjects.forEach(subject => this._messaging.subscribe(subject, callback))
	}

	async shutdown() {
		await this._messaging.disconnect()
	}
}
